import SuggestionNode from '../store/schema/SuggestionNode';
import { SmartComposeInteraction } from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';
import Suggestion from '../store/schema/Suggestion';

export default function initializeSuggestion(
    suggestionText: string,
    suggestionNode: SuggestionNode,
    suggestionTelemetry: SmartComposeInteraction
): Suggestion {
    return {
        suggestionText: suggestionText,
        suggestionNode: suggestionNode,
        suggestionTelemetry: suggestionTelemetry,
    };
}
